<template>
  <div
    class="card p-shadow-app"
    :style="{ position: 'relative' }"
    v-if="vehicles && vehicles.length > 0"
  >
    <ConfirmDialog group="homeFleet" />
    <Loading :active.sync="loading" :isFullPage="false"></Loading>
    <ReportForm
      :show="reportModel.show"
      :vehicleId="reportModel.vehicleId"
      :reportId="reportModel.reportId"
      :title="reportModel.title"
      v-on:cancel="closeReportForm"
      v-on:savedReport="closeReportForm"
    />
    <H4>Viaturas</H4>
    <div v-for="(vehicle, index) in vehicles" :key="vehicle.id">
      <Card v-if="vehicle.vehicle" class="p-mt-2">
        <template #title>
          <span
              class="clickable-item"
              @click="$router.push(`vehicle-details/${vehicle.vehicle.id}`)"
              >{{ vehicle.vehicle.registration }}
            </span>
        </template>
        <template #subtitle>
          {{ vehicle.vehicle.brand }} | {{ vehicle.vehicle.model }} |
          {{ vehicle.vehicle.color }}</template
        >
        <template #content>
          <p><b>Início da Utilização:</b> {{ vehicle.start }}</p>
          <DataTable
            v-if="vehicle.docs"
            :value="vehicle.docs"
            filterDisplay="row"
            :loading="loading"
            class="p-datatable-sm"
            :sortOrder="1"
            responsiveLayout="scroll"
            removableSort
            sortMode="single"
            :autoLayout="true"
          >
            <template #empty> Não existem Documentos. </template>
            <Column
              field="document_type"
              filterField="document_type"
              header="Tipo"
              filterMatchMode="contains"
            />
            <Column
              field="file_origin_name"
              filterField="document_type"
              header="Documento"
              filterMatchMode="contains"
            >
              <template #body="slotProps">
                <span
                  class="clickable-item"
                  @click="downloadFile(slotProps.data)"
                  >{{ slotProps.data.file_origin_name }}</span
                >
              </template>
            </Column>
          </DataTable>
        </template>
        <template #footer>
          <Button
            label="Desassociar Veículo"
            icon="pi pi-user-minus"
            class="p-button p-button-danger p-mr-2 p-mt-1"
            :disabled="loading"
            @click="confirmRemoveConductor(vehicle)"
          />
          <Button
            v-if="vehicle.docs == undefined"
            class="p-button-secondary p-mr-2 p-mt-1"
            icon="pi pi-file"
            label="Documentos"
            @click="getDocuments(vehicle.vehicle_id, index)"
          />
          <Button
            class="p-button-success p-mr-2 p-mt-1"
            icon="pi pi-plus"
            label="Relatório"
            @click="addReport(vehicle)"
          />
        </template>
      </Card>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import userService from "../services/user.service";
import fleetService from "../services/fleet.service";
import ReportForm from "../components/fleet/ReportForm.vue";
export default {
  name: "HomeFleet",
  components: {
    Loading,
    ReportForm
  },
  data() {
    return {
      loading: true,
      vehicles: [],
      reportModel: {
        show: false,
        vehicleId: null,
        reportId: null,
        title: null,
      },
    };
  },
  async created() {
    this.vehicles = await userService.getMyVehicles();
    this.loading = false;
  },
  methods: {
    confirmRemoveConductor(vehicle) {
      if (this.loading) return;
      this.$confirm.require({
        group: "homeFleet",
        header: "Desassociar Veículo",
        message: `Pretende terminar a sua utilização de ${vehicle.vehicle.registration}?`,
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim, desassociar",
        rejectLabel: "Cancelar",
        acceptClass: "p-button-danger",
        accept: async () => {
          if (this.loading) return;
          this.loading = true;
          try {
            const response = await fleetService.endVehicleReserve(vehicle.vehicle_id, vehicle.id);
            if (!response) throw new Error("Não foi possível terminar a utilização do veículo.");
            this.vehicles = this.vehicles.filter((use) => use.id !== vehicle.id);
            this.$emit("reservation-ended");
            this.$toast.add({ severity: "success", summary: "Veículo desassociado", life: 3000 });
          } catch (error) {
            this.$toast.add({
              severity: "error",
              summary: "Erro ao desassociar o veículo",
              detail: error.response && error.response.data && error.response.data.message
                || error.message || "Não foi possível terminar a utilização do veículo.",
              life: 5000,
            });
          } finally {
            this.loading = false;
          }
        },
      });
    },
    async getDocuments(vehicleId, index) {
      this.loading = true;
      this.vehicles[index]["docs"] = await fleetService.getPublicDocs(
        vehicleId
      );
      return (this.loading = false);
    },
    downloadFile(fileInfo) {
      return fleetService
        .getDocument(fileInfo.vehicle_id, fileInfo.id)
        .then((response) => {
          let url = window.URL.createObjectURL(new Blob([response]));
          let link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileInfo.file_origin_name);
          document.body.appendChild(link);
          link.click();
        });
    },
    addReport(info) {
      let title = `Veículo ${info.vehicle.brand} - ${info.vehicle.model} | ${info.vehicle.registration}`;
      return (this.reportModel = {
        show: true,
        vehicleId: info.vehicle.id,
        reportId: null,
        title: title,
      });
    },
    closeReportForm() {
      return (this.reportModel = {
        show: false,
        vehicleId: null,
        reportId: null,
        title: null,
      });
    }
  },
};
</script>
